import { fetchUserPermission } from '@/apis/auth'
import { httpRequest } from '@/apis/request'
import { getSurplusList } from '@/apis/surplusManage'
import { fetchPlankReference } from '@/apis/tag'
import { initGuiguiTranslate } from '@/data/i18n/guigui'
import { escapeTemplate } from '@/data/i18n/json/templateMap'
import { translateLang } from '@/data/i18n/translateLang'
import { IBigPlank } from '@/partTypes'
import store from '@/store'
import { IStateType } from '@/store/types'
import {
  judgeIsMergeFrameDoor,
  reversalPlank,
  rolloverPlank,
} from '@/util/LayoutFuncs'
import { pickNcPartFields } from '@/util/NcFileRelated'
import { bigPlankTemp } from '@/util/bigPlankTemp'
import EventBus from '@/util/bus'
import { EventBusKey } from '@/util/bus'
import { dealHighlightMatCode } from '@/util/commonFun'
import {
  canvas2Image,
  compare,
  cvs2image,
  fourTrimEdge,
  getOriginRect,
} from '@/util/commonFuncs'
import { JxTagData, countTagDataByDir } from '@/util/countTagData'
import {
  countSameSizeBoard,
  countSourceData,
  createLaveTag,
  createTag,
  getEdgeTypeWithRect,
  roomNameToChartMap,
} from '@/util/createTag'
import { convertJpegToBmp } from '@/util/file/convert'
import {
  _translateFileNameFn,
  dealJinxiPaibanFolder,
  dealTransFileName,
  genEngravingFileName,
} from '@/util/saveFile'
import { removeHeadAndTail } from '@/util/saveFile'
import {
  genFirstLevelFileName,
  getPaibanTime,
  getSurplusSize,
  judgeIsGenerateLaveTag,
} from '@/util/tag'
import { getGraghEdge } from '@/util/tag'
import { PartType, PlankType } from '@/views/materialsList/types/part'
import {
  getChildrenFolderFileSize,
  getFolderClassifyNameByMatCodeTextureThickSize,
} from '@/views/newPaiban/util/downLoadNC'
import { TagSettingType } from '@/views/printTag/type'
import { getSvgListToPdfJSBinary } from '@/views/printTag/utils/createPdf'
import { TagType, tagDraw } from '@/views/printTag/utils/drawTag'
import { timeSlice_ } from '@/views/printTag/utils/map-printTag'
import { message } from 'ant-design-vue'
import axios from 'axios'
import JSZip from 'jszip'
import Vue from 'vue'

import { checkIsOnlyProcessHoleSlotByPaibanData } from '../LayoutTool'
import { changeDataStartPoint } from '../NCGenerator'
import { transformToEzSort } from '../connect-color-label/transform'
import { dealLshapeTurnPoints } from '../dealPaibanData'
import { ensureTagDataDefaults } from '../defaultTagData'
import { exportBmp1Bit } from '../jimp'
import { getPartXyReverse } from '../plankCommonFuncs'
import { jsPdfTool } from '../tag/pdfFont'
import { initFabricNeedFont } from '../tag/tag-font'

type StoreType = { state: IStateType }
export type SettingType = {
  file_setting: { label: string; value: string }[]
  file_setting_delimiter: string
  file_setting_extra: { stock_num_length: number }
  nc_file_settings: {
    front: string
    labelMachineName: string
    machineCenterName: string
    stockNumLength: number
    customizeSetting: {
      headerIds: any
    }
  }
}
type Func = (...args: any) => any
type LifeFuncType = Partial<{
  loadSetting: Func
  loadPreferences: Func
  dealTemp: Func
  initialData: Func
  dealDrawData: Func
  genTagImg: Func
  genTagPdf: Func
  done: Func
}>

let _ncFileList: Array<{ file_display_name: string; [key: string]: any }> = []
const trimSide: string = store.state.isHistoryStatus
  ? window.sessionStorage.getItem('trimSide')
  : store.state.ncSetting.trimSide
/** 获取nc设置, 生产文件设置，只用于标签，从标签页抽取的逻辑 1 **/
export function getFileSetting(store: StoreType): Promise<SettingType | any> {
  return new Promise((resolve) => {
    const { ncSetting, userInfo } = store.state
    const params = {
      process_setting_id: ncSetting.process_setting_id || -1,
      uid: userInfo.id,
    }
    Vue.prototype.$token('/get_nc_file_settings', params, (res: any) => {
      if (!res.status) {
        throw new Error('错误')
      }
      const label_dict = res.data.label_dict
      const nc_file_settings = res.data.nc_file_settings
      const header_ids = nc_file_settings.customizeSetting.headerIds
      // 如果true，则使用_,这是为了兼容旧数据
      const file_setting_delimiter = nc_file_settings.hasDelimiter
        ? '_'
        : nc_file_settings.hasDelimiter
      const file_setting_extra = {
        stock_num_length: nc_file_settings.stockNumLength,
      }

      const ids: string[] = []
      let template_string = nc_file_settings.customizeSetting.templateString
      if (template_string) {
        if (nc_file_settings.hasDelimiter) {
          const spit = nc_file_settings.hasDelimiter
          template_string = template_string.split(spit).map((item: any) => {
            return item.match(/\{([^)]*)\}/)[1]
          })
        } else {
          template_string = template_string.slice(1, -1)
          template_string = template_string.split('}{')
        }
      } else template_string = []

      template_string.forEach((item: any) => {
        ids.push(header_ids[item])
      })
      const file_setting: any[] = []
      ids.forEach((id) => {
        const item = label_dict[String(id)]
        let label = '',
          value = ''
        if (item.label_name == 'direction') {
          label = 'front'
          value = nc_file_settings.front_info ?? nc_file_settings.front
        } else if (item.label_name == 'labelMachineName') {
          label = 'labelMachineName'
          value = nc_file_settings.labelMachineName
        } else if (item.label_name == 'machineCenterName') {
          label = 'labelMachineName'
          value = nc_file_settings.machineCenterName
        } else {
          label = item.label_name
        }
        file_setting.push({ label, value })
      })
      resolve({
        file_setting,
        file_setting_delimiter,
        file_setting_extra,
        nc_file_settings,
      })
    })
  })
}
// 获取nc文件设置 2
function getEngravingSetting(
  store: { state: IStateType },
  currentTemplate: any
): Promise<{ ncNameSuffix: string; ncOutputSetting: any }> {
  return new Promise((resolve) => {
    Vue.prototype.$token(
      '/load_engraving_setting',
      { setting_id: store.state.ncSetting.process_setting_id },
      (res: any) => {
        if (!res.status) {
          throw new Error('错误')
        }
        const ncNameSuffix =
          res.data.ncOutputSetting.fileType.fileNameType.toLowerCase()

        const ncOutputSetting = res.data.ncOutputSetting

        resolve({
          ncNameSuffix,
          ncOutputSetting,
        })
      }
    )
  })
}
// 获取偏好设置 3
export function getPreferencesSetting(): Promise<any> {
  return new Promise((resolve) => {
    const preference = store.state.preferencesSetting?.setting ?? {}
    const result = {
      ...preference,
      need_lave: preference.surplusLabel,
      need_lave_for_sur:
        preference.surplusLabelForSur ?? preference.surplusLabel,
      // bigPlankLabel 生成大板信息标签
      gen_big_plank_tag: preference.bigPlankLabel,
      gen_big_plank_surplus_tag:
        preference.bigPlankLabelForSur ?? preference.bigPlankLabel,
      // 生成小板信息标签
      gen_small_plank_tag: preference.genSmallPlankLabel,
      gen_small_plank_surplus_tag:
        preference.genSmallPlankLoaelForSurplus ??
        preference.genSmallPlankLabel,
      // 生成不下料板件标签
      genNoCutTag: preference.genNoCutTag ?? false,
      // labelCoord 大板标签贴标坐标
      xCoordinate: preference.labelCoord?.X ?? 0,
      yCoordinate: preference.labelCoord?.Y ?? 0,
      // mirrorLabel 	标签镜像
      jx_checked: preference.mirrorLabel,
      // // boardBenchmark 生成五六面钻放板基准标识
      five_six_dir: preference.boardBenchmark,
      // labelSortWay 标签排序适应自动上下料
      sort_value:
        preference.labelSortWay == 'default' ? 1 : preference.labelSortWay,
      print_setting: {
        // labelColumnNum 标签列数
        cols: preference.labelColumnNum,
        // labelColumnGap 多列标签列间距
        labelColumnGap: preference.col_space,
        // 特殊标记透明度
        opacity: preference.opacity ?? 0.24,
        // 特殊标记大小
        sizeAuto: preference.sizeAuto ?? 1,
        // 特殊标记自适应
        size: preference.size ?? true,
      },
      cutNeedLave: preference.cutNeedLave,
      cutNeedLaveForSur: preference.cutNeedLaveForSur ?? preference.cutNeedLave,
    }
    // 使用的 地方再次存储在了 vuex 中并未直接使用偏好设置的数据，会导致有些地方拿不到值，所以需要更新
    store.commit('setDrawOpacity', result.print_setting.opacity)
    store.commit('setDrawSizeAuto', result.print_setting.sizeAuto)
    store.commit('setDrawSize', result.print_setting.size)
    resolve(result)
  })
}
function showPartSize(part: any, field: string, needShowField: string) {
  const rect = getOriginRect(part, field)
  return (rect?.[needShowField] ?? 0).toFixed(2)
}

/**
 * @desc 翻转 用于标签的PDF和图片
 * @param plankList 小板列表
 * @param ncSetting nc设置
 */
export function rollOverTag(plankList: any, ncSetting: any) {
  // 判空
  if (!plankList || plankList.length <= 0) {
    return []
  }
  const xyReverse = ncSetting.xyReverse
  for (const plank of plankList) {
    // 小板列表
    const smallPlankList = plank.parts
    // 判空 单面板也不翻
    if (smallPlankList.length <= 0 || !plank.ableToggle) continue
    // 大板宽度
    const bigPWidth = plank.plankWidth
    // 大板高度
    const bigPHeight = plank.plankHeight

    smallPlankList.forEach((smallPlank: any) => {
      // L形余料的情况要特殊处理
      handlerPrimaryPlank(smallPlank, bigPWidth, bigPHeight, xyReverse)
      // 翻板(左右) xy互换需要上下翻
      xyReverse ? reversalPlank(smallPlank) : rolloverPlank(smallPlank, true)
    })
  }
}

/**
 * @desc 处理标签左右翻转时正常大板的情况
 * @param smallPlank 小班信息
 * @param bigPWidth 大板宽度
 * @param bigPHeight 大板高度
 * @param xyReverse xy互换
 */
function handlerPrimaryPlank(
  smallPlank: any,
  bigPWidth: number,
  bigPHeight: number,
  xyReverse: boolean
) {
  if (!xyReverse) {
    smallPlank.startX = bigPWidth - (smallPlank.startX + smallPlank.rect.width)
  } else {
    smallPlank.startY =
      bigPHeight - (smallPlank.startY + smallPlank.rect.height)
  }
}
// 初始化数据 4
export function initTagData(
  data: any[],
  store: StoreType,
  setting: SettingType,
  isNewGen?: boolean
) {
  const { file_setting, file_setting_delimiter, file_setting_extra } = setting
  const { ncSetting } = store.state
  data = JSON.parse(JSON.stringify(data))
  // 更改小板的startX 更改孔槽的所在面 也就是左右翻面 应急码 TURNBLANK
  if (
    ncSetting?.emergence_setting_key?.includes('TURNBLANK') &&
    ncSetting.labelOverturn
  ) {
    rollOverTag(data, ncSetting)
  }

  // 正反面条码填充值
  const front_file_identifier = ncSetting.front_file_identifier
  const opposite_file_identifier = ncSetting.opposite_file_identifier
  // 记录有几个柜子
  const wardrobe_names: any = {}
  let record_wardrobe_num = 0
  data.forEach((item, index) => {
    item.parts.forEach((part: any) => {
      if (
        (!part.specialType ||
          (part.specialType && part.specialType !== 'supplus')) &&
        !part.surplusPath
      ) {
        part.oriPlankNumF = `${part.plankNum}${opposite_file_identifier}`
        if (front_file_identifier) {
          const pn = String(part.plankNum)
          part.plankNum = isNewGen ? pn : `${pn}${front_file_identifier}`
          part.oriPlankNum = part.plankNum
        }
      }

      let label_img_name = ''
      if (ncSetting.labelFormat === 'jingmei') {
        label_img_name += `${item.parts[0].address}_`
        file_setting.forEach((set) => {
          if (
            set.label === 'front' ||
            set.label === 'labelMachineName' ||
            set.label === 'machineCenterName'
          ) {
            if (set.value) {
              if (file_setting_delimiter) label_img_name += `${set.value}_`
              else label_img_name += `${set.value}`
            }
          } else {
            if (file_setting_delimiter) {
              if (set.label === 'stockNum') {
                if (
                  String(index + 1).length < file_setting_extra.stock_num_length
                )
                  label_img_name += `${prefixInteger(
                    index + 1,
                    file_setting_extra.stock_num_length
                  )}_`
                else label_img_name += `${index + 1}_`
              } else label_img_name += `${part[set.label]}_`
            } else {
              if (set.label === 'stockNum') {
                if (
                  String(index + 1).length < file_setting_extra.stock_num_length
                )
                  label_img_name += `${prefixInteger(
                    index + 1,
                    file_setting_extra.stock_num_length
                  )}`
                else label_img_name += `${index + 1}`
              } else label_img_name += `${part[set.label]}`
            }
          }
        })
      }
      part.lableImgName =
        label_img_name +
        (ncSetting.genSimpleLabelBarcode
          ? part.simplePlankNum
          : part.oriPlankNum)

      if (wardrobe_names.hasOwnProperty(`${part.loc}_${part.roomID}`))
        part.wardrobeNum = wardrobe_names[`${part.loc}_${part.roomID}`]
      else {
        record_wardrobe_num++
        wardrobe_names[`${part.loc}_${part.roomID}`] = record_wardrobe_num
        part.wardrobeNum = wardrobe_names[`${part.loc}_${part.roomID}`]
      }
      // 将宽高恢复成默认顺序
      const oSizeRect = getOriginRect(part)
      const oSizeCutRect = getOriginRect(part, 'realRect')
      if (part.srcTexDir == 'reverse') {
        const copyOSize = JSON.parse(JSON.stringify(oSizeRect))
        const copyOSizeCut = JSON.parse(JSON.stringify(oSizeCutRect))
        oSizeRect.width = copyOSize.height
        oSizeRect.height = copyOSize.width
        oSizeCutRect.width = copyOSizeCut.height
        oSizeCutRect.height = copyOSizeCut.width
      }
      // 定义特殊字段
      // 成品尺寸
      part.oSize = `${(+oSizeRect.height).toFixed(
        2
      )}*${(+oSizeRect.width).toFixed(2)}*${part.thick}`
      // 切割尺寸
      const width =
        oSizeCutRect.width - Number(part.edgePreMillingInfo?.width * 2 || 0)
      const height =
        oSizeCutRect.height - Number(part.edgePreMillingInfo?.width * 2 || 0)
      part.cutSize = `${height.toFixed(2)}*${width.toFixed(2)}*${part.thick}`
      // 材质
      part.matCode_texture = `${dealHighlightMatCode(
        part._oriMatCode || part.matCode
      )}-${part._oriTexture || part.oriTexture || part.texture}`

      part.handle_name = ''
      if (
        part.handle &&
        part.handle.partsChildren &&
        part.handle.partsChildren.length
      )
        part.handle_name =
          part.handle.partsChildren[0].maskPartName ||
          part.handle.partsChildren[0].matSpec
            ? `${
                part.handle.partsChildren[0].maskPartName ||
                part.handle.partsChildren[0].matSpec
              }_${part.handle.partsChildren[0].name}`
            : ''

      if (Array.isArray(part.partsChildren)) {
        part.partsChildren.forEach((p_c: any) => {
          if (p_c.name.includes('铰链'))
            part.hinge_label = p_c.maskPartName || p_c.matSpec || ''
          else if (p_c.name.includes('拉直器'))
            part.straightener_label = p_c.maskPartName || p_c.matSpec || ''
        })
      }
    })
  })
  let tagLength = 0
  for (let i = 0; i < data.length; i++) {
    const plank = data[i]
    plank.parts = plank.parts.sort(compare('priority', 'up', 'priority'))
    tagLength += plank.parts.length
  }
  return {
    data,
    tagLength,
  }
}
// 初始化余料数据 5
export function initLaveData(sourceData: any[], store: StoreType) {
  const { ncSetting } = store.state
  const lave_data: any[] = []
  sourceData.forEach((item, index) => {
    // 仅加工孔槽的板件无废料标签
    if (checkIsOnlyProcessHoleSlotByPaibanData([item], null)) {
      return
    }
    const usedRate = item.realUsedRate
    const usedArea = item.realAreaTotal
    // 是否生成余料标签
    const isGenerateLaveTag = judgeIsGenerateLaveTag(usedRate, usedArea)
    const supplus = [item.parts]
    if (!supplus.length || !isGenerateLaveTag) return
    supplus.forEach((sup) => {
      const panel = {
        ...item,
        texture: item.texture,
        orderNo: sup[0].orderNo,
        roomName: sup[0].roomName,
        matCode: sup[0].matCode,
        parts: sup,
        thick: sup[0].thick,
        plankHeight: item.plankHeight,
        plankWidth: item.plankWidth,
        plankSize: '',
        lableImgName: new Date().getTime(),
        surplusInfo: item.surplusInfo,
        plank_index: index + 1,
        path: item.path,
      }
      if (sup[0].specialType === 'supplus') {
        panel.plankSize = getSurplusSize(sup[0], ncSetting).str
      }
      lave_data.push(panel)
    })
  })
  return lave_data
}

export const SUB_TAG_TYPE = 'subTag'

/** 小板主标签 / 副标签 */
export function isPartTagType(type?: string) {
  return type === 'tag' || type === SUB_TAG_TYPE
}

const SUB_TAG_SKIP_TYPES = new Set([
  'controlRect',
  'TageBox',
  'holeSlotPicture-size',
  'holeSlotPicture-edge',
])

/** 存在即生成副标签，不要求运行时有值 */
const SUB_TAG_ALWAYS_GEN_TYPES = new Set([
  'Typography',
  'Onecode',
  'QRcode',
  'wardrobeNum',
  'Marking',
  'smallPlateMarking',
  'specialMark',
  'sixSideDrillArrow',
  'sixSideDrillTriangle',
  'holeSlotPicture',
  'Table',
  'EdgeBand',
  'VisibleEdge',
])

function isNonEmptyString(val: unknown) {
  return typeof val === 'string' && val.trim() !== ''
}

const SUB_TAG_PLACEHOLDER_TEXTS = [
  '请双击输入文本',
  '请选择对应数据项',
  'undefined',
  'null',
]

function isPlaceholderText(text?: unknown) {
  if (text === undefined || text === null) {
    return true
  }
  if (!isNonEmptyString(text)) {
    return true
  }
  return SUB_TAG_PLACEHOLDER_TEXTS.includes(String(text).trim())
}

function getSubTagSourceText(item: any, mainTag?: any, template?: any) {
  if (!mainTag?.part || !item?.data) {
    return ''
  }
  // 未选择数据源
  if (
    item.data.source_data === undefined ||
    item.data.source_data === null ||
    !isNonEmptyString(item.data.source_data)
  ) {
    return ''
  }
  const text = countSourceData(
    mainTag.part,
    mainTag.plank,
    mainTag.plank_index,
    1,
    { tem_data: template?.sub_tem_data || [] },
    null,
    item.data,
    0,
    { genTagWay: 'preview' }
  )
  if (isPlaceholderText(text)) {
    return ''
  }
  return String(text).trim()
}

/** 副标签绘制结果是否只有空白画布 */
export function isBlankTagSvg(svgHtml?: string) {
  if (!svgHtml || !String(svgHtml).trim()) {
    return true
  }
  const html = String(svgHtml)
  if (html.startsWith('data:image')) {
    return false
  }
  const cleaned = html
    .replace(/<desc[\s\S]*?<\/desc>/gi, '')
    .replace(/<title[\s\S]*?<\/title>/gi, '')
    .replace(/<!--[\s\S]*?-->/g, '')
  const textNodes = cleaned.match(/<text\b[\s\S]*?<\/text>/gi) || []
  if (textNodes.some((node) => node.replace(/<[^>]+>/g, '').trim())) {
    return false
  }
  return !/<(image|path|polygon|polyline|circle|ellipse|line)[\s>/]/i.test(
    cleaned
  )
}

/**
 * 更多设置-小板副标签：开启生效数据源时返回白名单；未开启返回 null（走默认规则）。
 * 白名单内多项为「或」关系。
 */
function getSubTagEffectiveSourceKeys(): Set<string> | null {
  const preference = store.state.preferencesSetting?.setting ?? {}
  if (!preference.enableSubTagDataSource) {
    return null
  }
  const list = (preference.subTagDataSource || []).filter((key: unknown) =>
    isNonEmptyString(key)
  )
  return new Set(list)
}

/**
 * 副标签模板项是否足以触发生成。
 * 固定文本 / 固定图形不生成；数据源未选或值为空不生成。
 * 未限制生效数据源时：排版图、条码、二维码等存在即生成。
 * 已限制时：仅白名单数据源且有值才生成（忽略排版图等），白名单项之间为或。
 */
export function isSubTagItemHasContent(
  item: any,
  mainTag?: any,
  template?: any,
  allowedSourceKeys?: Set<string> | null
) {
  if (!item?.type || SUB_TAG_SKIP_TYPES.has(item.type)) {
    return false
  }
  // 固定图形不触发副标签
  if (item.type === 'Graphics') {
    return false
  }

  // 开启生效数据源限制：只认配置的数据源，排版图/条码等不再触发生成
  if (allowedSourceKeys) {
    if (item.type !== 'DataSource') {
      return false
    }
    if (!allowedSourceKeys.has(item.data?.source_data)) {
      return false
    }
    if (
      item.data?.source_data === undefined ||
      item.data?.source_data === null ||
      !isNonEmptyString(item.data?.source_data)
    ) {
      return false
    }
    try {
      return Boolean(getSubTagSourceText(item, mainTag, template))
    } catch (e) {
      return false
    }
  }

  if (SUB_TAG_ALWAYS_GEN_TYPES.has(item.type)) {
    return true
  }
  if (item.type !== 'DataSource') {
    return false
  }
  // 数据源未选择（undefined / 空）
  if (
    item.data?.source_data === undefined ||
    item.data?.source_data === null ||
    !isNonEmptyString(item.data?.source_data)
  ) {
    return false
  }
  try {
    return Boolean(getSubTagSourceText(item, mainTag, template))
  } catch (e) {
    return false
  }
}

/** 模板已开启副标签，且存在非空的可绘制内容 */
export function canGenSmallPlankSubTag(template?: any, mainTag?: any) {
  if (!template?.enable_sub) {
    return false
  }
  const allowedSourceKeys = getSubTagEffectiveSourceKeys()
  return (template.sub_tem_data || []).some((item: any) =>
    isSubTagItemHasContent(item, mainTag, template, allowedSourceKeys)
  )
}

/**
 * @description 导出/下载前校验副标签权限。模板开启副标且权限过期时 toast 并拦截
 * @returns true 可继续；false 已拦截
 */
export async function validateSubTagPerForExport(
  template?: { enable_sub?: boolean } | null
): Promise<boolean> {
  if (!template?.enable_sub) {
    return true
  }
  try {
    const res = await fetchUserPermission({
      permission_type: 'SECONDARY_LABEL',
    })
    if (res.status && res.data?.enable) {
      return true
    }
  } catch (e) {
    // 请求失败按权限过期处理
  }
  message.error(
    translateLang(
      '输出生产文件包含付费的副标签权限，该功能已过期需关闭后重新输出'
    )
  )
  return false
}

/** 绘制时：副标签使用独立的 sub_tem_data 副本 */
export function getTagDrawTemplate(template: any, isSubTag: boolean) {
  if (!isSubTag || !template) {
    return template
  }
  return {
    ...template,
    tem_data: JSON.parse(JSON.stringify(template.sub_tem_data || [])),
  }
}

/** 导出图片名在扩展名前加 (副) */
export function appendSubTagFileNameSuffix(
  fileName: string,
  item?: { type?: string }
) {
  if (item?.type === SUB_TAG_TYPE) {
    return `${fileName}(副)`
  }
  return fileName
}

/** 推入小板主标签后紧跟副标签，页码按列表长度连续 */
export function pushSmallPlankTagWithSub(
  allTagList: any[],
  mainTag: any,
  template?: any
) {
  allTagList.push(mainTag)
  if (!canGenSmallPlankSubTag(template, mainTag)) {
    return
  }
  allTagList.push({
    ...mainTag,
    type: SUB_TAG_TYPE,
    part: {
      ...JSON.parse(JSON.stringify(mainTag.part || {})),
      page: allTagList.length + 1,
    },
  })
}

function resetTagListPage(tagList: any[]) {
  tagList.forEach((item, index) => {
    if (item.part) {
      item.part.page = index + 1
    }
  })
}

// 标签图片绘制前的处理 6
export function tagDrawPreDeal(
  sourceData: any,
  ncNameSuffix: string,
  setting: SettingType,
  preSetting: any,
  ncSetting: any,
  ncOutputSetting?: any,
  preferencesSetting?: any,
  currentTemplate?: any
) {
  const {
    gen_big_plank_tag,
    gen_big_plank_surplus_tag,
    cutNeedLave,
    cutNeedLaveForSur,
    gen_small_plank_tag,
    gen_small_plank_surplus_tag,
    genNoCutTag,
  } = preSetting
  const { file_setting, file_setting_delimiter, nc_file_settings } = setting
  const tagListSourceData = []
  const bigTagList = []
  for (let index = 0; index < sourceData.length; index++) {
    const plank = sourceData[index]
    const parts = sourceData[index].parts
    const isSurplusPlank =
      sourceData[index]?.surplusInfo &&
      !sourceData[index]?.surplusInfo?.other_plate
    const { size } = getGraghEdge(plank)
    let partNCName = ''
    const headersIds = nc_file_settings.customizeSetting.headerIds
    // 大板信息
    const plankObj: any = {
      plank,
      plank_index: index + 1, // 第几张大板
      part: {
        ...parts[0],
        page: tagListSourceData.length + 1, //第几页
      },
      type: 'plank',
    }
    let ncName = file_setting
      .map((item) => {
        if (item.value) {
          return item.value
        } else {
          const stockNumLength = nc_file_settings.stockNumLength
          if (item.label === 'stockNum' && stockNumLength) {
            const value = plankObj.plank_index + '' // 序号用第几块板，如果不对，就把sourceData用stockNum进行排序
            return value.padStart(stockNumLength, '0')
          } else if (item.label === 'front') {
            return nc_file_settings.front || plankObj.part.front || '正面'
          } else if (item.label === 'matCode') {
            // 材质需要对高光名称单独处理
            return (
              dealHighlightMatCode(
                plankObj.part._oriMatCode || plankObj.part.matCode
              ) ||
              plankObj.part._oriMatCode ||
              plankObj.part.matCode
            )
          } else if (item.label == 'high_gloss_side_reverse') {
            return plank.hasAutoRollOver
              ? ncSetting.custom_high_gloss_reverse
              : ''
          } else if (item.label === 'trim_edge') {
            // 如果是自定义修四边
            if (plankObj.plank.margin.toString()?.includes(',')) {
              const trimEdges = plankObj.plank.margin.split(',')
              return `上${trimEdges[0]}下${trimEdges[1]}左${trimEdges[2]}右${trimEdges[3]}`
            }
            return plankObj.plank.margin ?? ''
          } else {
            return plankObj.part[item.label]
          }
        }
      })
      .filter(Boolean)
      .join(file_setting_delimiter)

    // 如果没有大板序号，手动加上
    if (!headersIds['大板序号']) {
      ncName = plankObj.plank_index + file_setting_delimiter + ncName
    }

    // nc导出设置里选择了正反面且开启了正反面合并，去掉正反面相关字段
    if (
      Object.keys(ncOutputSetting).length &&
      headersIds['正面/反面'] &&
      ncOutputSetting.fileMerge.doubleEdgeCombine
    ) {
      const frontStr = ncOutputSetting.fileNameSetting.front_info
        ? ncOutputSetting.fileNameSetting.front_info
        : '正面'
      const backStr = ncOutputSetting.fileNameSetting.back_info
        ? ncOutputSetting.fileNameSetting.back_info
        : '反面'
      const reg = new RegExp(
        `\\${file_setting_delimiter}${frontStr}|\\${file_setting_delimiter}${backStr}`,
        'gi'
      )
      ncName = ncName.replace(reg, '')
    }
    // 给ncName加上后缀
    ncName = `${ncName}.${ncNameSuffix}`

    partNCName = ncName

    if (gen_big_plank_tag || gen_big_plank_surplus_tag) {
      // 大板绘制信息
      const normalPart = plank.parts.find((part: any) => !part.specialType)
      const plankDrawMsg = {
        programAddress: normalPart
          ? normalPart.address
          : plank.parts[0].address,
        orderNo: normalPart ? normalPart.orderNo : plank.parts[0].orderNo,
        material:
          plank.thick +
          dealHighlightMatCode(plank.matCode) +
          (plank.oriBigTexture ?? plank.texture),
        size,
        ncName,
        qrCode: ncName,
        plank_index: `第${plankObj.plank_index}张大板`,
        lable_index: ``,
      }
      // 把 plankDrawMsg、graghEdge 放到 plank 里面
      plankObj.plank = {
        ...plankObj.plank,
        plankDrawMsg,
        isGenNcSuffix: preSetting.isGenNcSuffix,
      }
      if (
        ((gen_big_plank_surplus_tag && isSurplusPlank) ||
          (gen_big_plank_tag && !isSurplusPlank) ||
          (gen_big_plank_tag && gen_big_plank_surplus_tag)) &&
        (!genNoCutTag || !plank.isDesMaterialNoCut)
      ) {
        tagListSourceData.push(plankObj)
        bigTagList.push(plankObj)
      }
    }
    if (
      gen_small_plank_tag ||
      gen_small_plank_surplus_tag ||
      cutNeedLave ||
      cutNeedLaveForSur ||
      genNoCutTag
    ) {
      const newParts: PartType[] & Partial<IBigPlank[]> = parts
      // if (!gen_small_plank_tag && cutNeedLave) {
      //   newParts = parts.filter(
      //     (item: PartType) => item?.specialType === 'supplus'
      //   )
      // }
      for (let p_index = 0; p_index < newParts.length; p_index++) {
        if (!newParts[p_index].surplusInfo) {
          newParts[p_index].surplusInfo = plank?.surplusInfo
        }
        const isSmllPartTagForNor =
          !newParts[p_index]?.specialType && !isSurplusPlank
        const isCutTagForNor =
          newParts[p_index]?.specialType === 'supplus' && !isSurplusPlank
        const isSmllPartTagForSur =
          !newParts[p_index]?.specialType && isSurplusPlank
        const isCutTagForSur =
          newParts[p_index]?.specialType === 'supplus' && isSurplusPlank
        const obj: any = {
          plank: {
            ...sourceData[index],
          },
          part: {
            ...(JSON.parse(JSON.stringify(newParts[p_index])) || {}),
            page: tagListSourceData.length + 1,
            ncName: partNCName,
            texture:
              newParts[p_index]._oriTexture ||
              newParts[p_index].oriTexture ||
              newParts[p_index].texture,
          },
          plank_index: index + 1,
          part_index: p_index,
          currentPlank: newParts[p_index],
          type: 'tag',
        }
        // if (!(!cutNeedLave && newParts[p_index].specialType == 'supplus')) {
        //   tagListSourceData.push(obj)
        // }
        // 不下料板件在 genNoCutTag 开启时只走 genNoCutTag 路径，避免重复
        const isNoCutPart = genNoCutTag && newParts[p_index].isDesMaterialNoCut
        if (gen_small_plank_tag && isSmllPartTagForNor && !isNoCutPart) {
          pushSmallPlankTagWithSub(tagListSourceData, obj, currentTemplate)
        }
        if (
          gen_small_plank_surplus_tag &&
          isSmllPartTagForSur &&
          !isNoCutPart
        ) {
          pushSmallPlankTagWithSub(tagListSourceData, obj, currentTemplate)
        }
        if (cutNeedLave && isCutTagForNor && !isNoCutPart) {
          tagListSourceData.push(obj)
        }
        if (cutNeedLaveForSur && isCutTagForSur && !isNoCutPart) {
          tagListSourceData.push(obj)
        }
        if (genNoCutTag && newParts[p_index].isDesMaterialNoCut) {
          tagListSourceData.push(obj)
        }
      }
    }
  }
  resetTagListPage(tagListSourceData)
  const all_page =
    tagListSourceData.length +
    (preferencesSetting?.need_lave || preferencesSetting?.need_lave_for_sur
      ? bigTagList.length
      : 0)
  if (bigTagList.length) {
    // 修改每个属性的label_index信息
    bigTagList.forEach((item) => {
      item.plank.plankDrawMsg.lable_index = `第${item.part.page}/${all_page}页`
    })
  }
  return { tagListSourceData, bigTagList, all_page }
}
// 余料标签图片绘制前的处理 7
export function laveTagDrawPreDeal(
  laveData: any,
  preferencesSetting: Record<string, any>
) {
  const laveTagListSourceData = []
  const { need_lave_for_sur, need_lave } = preferencesSetting
  for (let index = 0; index < laveData.length; index++) {
    const plank = laveData[index]
    const obj = {
      plank,
      plank_index: plank.plank_index,
      type: 'laveTag',
    }
    if (
      laveData[index].surplusInfo &&
      !laveData[index]?.surplusInfo?.other_plate &&
      need_lave_for_sur
    ) {
      laveTagListSourceData.push(obj)
    }
    if (
      (!laveData[index]?.surplusInfo ||
        laveData[index]?.surplusInfo?.other_plate) &&
      need_lave
    ) {
      laveTagListSourceData.push(obj)
    }
  }
  return laveTagListSourceData
}
// 获取collect数据
// 生成图片标签 8
export async function generateImageTag(
  tagListSourceData: any[],
  laveTagListSourceData: any[],
  currentTemplate: any,
  store: StoreType,
  setting: any,
  drawData: any[]
): Promise<{
  collect: any[]
  collectSvg: any[]
  bigplantLableList: any[]
  LaveTagBase64List: any[]
}> {
  const { ncSetting, preferencesSetting } = store.state
  const {
    all_page,
    jx_checked,
    five_six_dir,
    scale,
    sort_value,
    cutNeedLave,
    cutNeedLaveForSur,
    need_lave,
    need_lave_for_sur,
    isGenNcSuffix,
    printColorTag,
    genPartColorRevert,
    cutLaveEndForSur,
  } = setting
  const { cutLaveEnd } = preferencesSetting?.setting ?? {}
  return new Promise(async (resolve) => {
    await initFabricNeedFont()
    await initGuiguiTranslate()
    const isTemp = false
    // 收集所有图片
    const collect: {
      fileName: string
      url: string
      stock_key: string
      size: string
      surplusInfo: boolean
    }[] = []
    const collectSvg: { url: string }[] = []
    const bigplantLableList: { url: string }[] = []
    const LaveTagBase64List: { url: string }[] = []
    // 收集余料图片
    // 获取板件是否需要逆时针旋转
    let isRotatePlank = false
    const typographyKlass = currentTemplate.tem_data.find(
      (it: any) => it.type === 'Typography'
    )
    if (typographyKlass) {
      isRotatePlank = typographyKlass.data.plankRotate
    }
    const finalData = [...tagListSourceData]

    // 将废料标签分成标准大板和余料大板
    const laveTagListSourceDataForStandard = laveTagListSourceData.filter(
      (item) => !item.plank.surplusInfo
    )
    const laveTagListSourceDataForSurplus = laveTagListSourceData.filter(
      (item) => item.plank.surplusInfo
    )

    // 开启生成大板的废料标签
    if (need_lave) {
      if (cutLaveEnd) {
        laveTagListSourceDataForStandard.forEach((item) => {
          const index = finalData.findIndex(
            (it) => it.plank_index > item.plank_index
          )
          if (index === -1) {
            finalData.push(item)
          } else {
            finalData.splice(index, 0, item)
          }
        })
      } else {
        finalData.push(...laveTagListSourceDataForStandard)
      }
    }
    // 开启生成余料大板的废料标签
    if (need_lave_for_sur) {
      if (cutLaveEndForSur) {
        laveTagListSourceDataForSurplus.forEach((item) => {
          const index = finalData.findIndex(
            (it) => it.plank_index > item.plank_index
          )
          if (index === -1) {
            finalData.push(item)
          } else {
            finalData.splice(index, 0, item)
          }
        })
      } else {
        finalData.push(...laveTagListSourceDataForSurplus)
      }
    }

    // 根据finalData统计房间，柜体编号
    const tagDataList = finalData.filter((item: any) => item.type === 'tag')
    const roomNameMap = roomNameToChartMap(tagDataList)
    const statisticsCount = countSameSizeBoard(tagDataList)
    const judgeLimit = store.state.limitOvers.length
    // 获取所有余料 余料标签所在余料库使用
    const surRes = await getSurplusList({ page: 1, limit: 999 })
    const allSurplusList = surRes.status ? surRes.data.data : []
    const len = finalData.length

    let idx = 0
    let ncFileList: any[] = []
    async function next() {
      await new Promise((resolve) => setTimeout(resolve, 50))
      if (idx >= len) {
        resolve({
          collect,
          collectSvg,
          bigplantLableList,
          LaveTagBase64List,
        })
        return
      }
      const current = finalData[idx++]
      if (!current) {
        return
      }
      // 大板序号补偿位数
      current.plank_index = plankOrderCompensationDigits(
        current.plank_index,
        ncSetting?.labelingSetting?.stockNumOffset ?? 1
      )
      let svgUrl = null
      const surplusInfo =
        current.plank.surplusInfo && !current.plank.surplusInfo?.other_plate
      const stock_key = current.plank.stockKey
        ? current.plank.stockKey.split(':').slice(0, -1).join(':')
        : `${current.plank._oriTexture || current.plank.texture}:${
            current.plank._oriMatCode || current.plank.matCode
          }:${current.plank.thick}`
      if (current.plank.parts[0].surplusInfo && !current.plank.surplusInfo) {
        current.plank.surplusInfo = current.plank.parts[0].surplusInfo
      }
      const folderSize = getChildrenFolderFileSize(current.plank, ncSetting)
      if (isPartTagType(current.type)) {
        // 当是标签时(收集标签时要满足收集余料标签时是开启了)
        if (
          current.part.specialType !== 'supplus' ||
          (current.part.specialType === 'supplus' &&
            (cutNeedLave || cutNeedLaveForSur))
        ) {
          let gen_part_color_revert = genPartColorRevert
          // 应急码设置了特殊标记 并且有特殊标记时 才生效标签反色
          if (ncSetting?.emergence_setting_key?.includes('specialMark')) {
            const specialMark =
              current.part.specialFlag ?? current.part.specTagTemplate
            gen_part_color_revert =
              specialMark && specialMark !== 'default'
                ? gen_part_color_revert
                : false
          }
          const isSubTag = current.type === SUB_TAG_TYPE
          const drawTemplate = getTagDrawTemplate(currentTemplate, isSubTag)
          const subTypography = drawTemplate?.tem_data?.find(
            (it: any) => it.type === 'Typography'
          )
          const tagRotatePlank = isSubTag
            ? Boolean(subTypography?.data?.plankRotate)
            : isRotatePlank
          await escapeTemplate(drawTemplate)
          const prevCollectLen = collect.length
          const labelNum = idx - 1
          svgUrl = await createTag(
            {
              ...drawTemplate,
              roomNameMap,
              print_color_tag: printColorTag,
              judgeLimit,
              statisticsCount,
              allSurplusList,
              gen_part_color_revert,
            },
            current.plank,
            current.part,
            current.plank_index,
            current.part_index,
            finalData.length,
            jx_checked,
            five_six_dir,
            {
              scale,
              trimSide,
            },
            ncSetting,
            current.currentPlank,
            collect,
            sort_value,
            isTemp,
            cutNeedLave || cutNeedLaveForSur,
            tagRotatePlank,
            labelNum
          )
          if (isSubTag && isBlankTagSvg(svgUrl)) {
            if (collect.length > prevCollectLen) {
              collect.length = prevCollectLen
            }
            svgUrl = null
          } else {
            const exportNameRes = await dealExportTagFileName(
              current,
              store,
              ncFileList,
              drawData
            )
            ncFileList = exportNameRes.ncFileList
            const fileName = exportNameRes.fileName
            _ncFileList = ncFileList.filter((i) => {
              if (i.filetype === 'nc' && i.direction === 'front') {
                return i
              }
            })
            transformToEzSort.changeImageFileName(
              current.part,
              fileName,
              ncSetting?.labelImageFormat,
              labelNum
            )
            await dealMergeFileNameOrUrl(
              fileName,
              collect,
              ncSetting,
              stock_key,
              folderSize,
              surplusInfo,
              { current }
            )
          }
        }
      } else if (current.type === 'plank') {
        const { size } = getGraghEdge(current.plank)
        current.plank.plankSize = size
        await escapeTemplate(bigPlankTemp)
        // 大板标签
        svgUrl = await createTag(
          {
            ...bigPlankTemp,
            tag_width: currentTemplate.tag_width,
            tag_height: currentTemplate.tag_height,
          },
          {
            ...current.plank,
            isGenNcSuffix,
          },
          current.part,
          current.plank_index,
          null,
          finalData.length,
          jx_checked,
          false,
          { scale, trimSide },
          ncSetting,
          current.currentPlank,
          collect,
          sort_value,
          isTemp,
          false,
          isRotatePlank,
          idx - 1
        )
        //
        const base64 = svgToBase64(svgUrl)
        bigplantLableList.push({ url: base64 })
        const { fileName, ncFileList: ncFileArr } = await dealExportTagFileName(
          current,
          store,
          ncFileList,
          drawData
        )

        ncFileList = ncFileArr
        await dealMergeFileNameOrUrl(
          fileName,
          collect,
          ncSetting,
          stock_key,
          folderSize,
          surplusInfo,
          { current }
        )
      } else {
        await escapeTemplate(currentTemplate)
        // 当是余料标签时
        svgUrl = await createLaveTag(
          currentTemplate,
          current.plank,
          current.plank_index,
          { scale },
          ncSetting,
          collect,
          isRotatePlank,
          // 参数设置
          finalData.length,
          tagListSourceData.length,
          idx - 1
        )
        const base64 = svgToBase64(svgUrl)
        LaveTagBase64List.push({ url: base64 })
        const fileName = dealExportLaveTagFileName(current, store)
        await dealMergeFileNameOrUrl(
          fileName,
          collect,
          ncSetting,
          stock_key,
          folderSize,
          surplusInfo,
          { current }
        )
      }
      if (svgUrl) {
        collectSvg.push({
          url: svgUrl,
        })
      }
      next()
    }
    // 执行
    next()
  })
}

// 生成图片zip
export async function createTagImageZip(
  target: any,
  store: StoreType,
  templateName: string,
  paibanData: any[],
  flag: boolean
) {
  const {
    collect: collectTagList,
    bigplantLableList,
    LaveTagBase64List,
  } = target
  const { ncSetting } = store.state
  const { label_img_big_plank_folder, isMergeFile } = ncSetting
  const { label_image_in_nc_folder } = ncSetting.folderCategory
  const hasLabelImageInNcFolderPermission =
    store.state.userPermissions['label_image_in_nc_folder'] &&
    label_image_in_nc_folder
  // 一级文件名
  let firstLevelFileName = ''
  let originFileNameData: any = {}
  // 收集贴标图信息(二维数组是为了统一遍历是否分文件夹)
  const labelImgList = [[]] as {
    name: string
    url: string
    stock_key: string
    size: string
    surplusInfo: boolean
  }[][]
  try {
    const obj = await genFirstLevelFileName(true)
    firstLevelFileName = obj.firstLevelFileName
    originFileNameData = obj.data
  } catch (error) {
    console.error('err', error)
  }
  const {
    merge_folder_list,
    platePropertyMergeFile,
    merge_folder_display_name,
    is_gen_surplus_folder,
  } = ncSetting.customizeFolder
  // 定制需求 label_image_in_nc_folder一般是false，只有一个客户才会有此需求
  const imgFileName =
    store.state.isFollowExportTag &&
    hasLabelImageInNcFolderPermission &&
    label_image_in_nc_folder &&
    merge_folder_list.length <= 1
      ? originFileNameData.engraving_folder + '/label/image'
      : originFileNameData.label_image_folder || templateName
  const preferencesSetting = await getPreferencesSetting()

  const zip = new JSZip()
  let currentZip = zip
  let idx = 0
  //  没有开启开料机文件合并功能并且勾选了根据大板分为不同文件夹
  if (!isMergeFile && label_img_big_plank_folder) {
    const folders = zip.folder('')
    const time = Date.now() + 8 * 3600 * 1000
    for (let j = 0; j < paibanData.length; j++) {
      const item = paibanData[j]
      labelImgList[j] = []
      const idy = _ncFileList.findIndex((i) => i.stock_key === item.stockKey)
      let list: any[] = []
      // 处理当开启了自动余料裁剪但是没有勾选生成余料的情况
      if (!preferencesSetting.cutNeedLave) {
        item.parts = item.parts.filter(
          (i: any) =>
            !(
              i.specialType === 'supplus' &&
              (!i.surplusInfo || i.surplusInfo?.other_plate)
            )
        )
      }
      if (!preferencesSetting.cutNeedLaveForSur) {
        item.parts = item.parts.filter(
          (i: any) =>
            !(
              i.specialType === 'supplus' &&
              i.surplusInfo &&
              !i.surplusInfo?.other_plate
            )
        )
      }
      // 生成的每个文件夹中图片的数量
      if (!!bigplantLableList.length && !!LaveTagBase64List.length) {
        list = [bigplantLableList[j], ...item.parts, LaveTagBase64List[j]]
      } else if (!bigplantLableList.length && !!LaveTagBase64List.length) {
        list = [...item.parts, LaveTagBase64List[j]]
      } else if (!!bigplantLableList.length && !LaveTagBase64List.length) {
        list = [bigplantLableList[j], ...item.parts]
      } else {
        list = [...item.parts]
      }
      const dirname = _ncFileList[idy].file_display_name.slice(0, -3)
      if (firstLevelFileName) {
        const folder = await folders?.folder(`${dirname}`)
        // 这一步是手动修改文件的更新时间
        zip.file(dirname + '/', '', { date: new Date(time) })
        if (folder) currentZip = folder
      }
      list.forEach((item, indey) => {
        let it = collectTagList[idx].url.split(',')[1]
        let filename = collectTagList[idx].fileName
        if (indey === list.length - 1 && LaveTagBase64List.length) {
          // 当前文件夹余料标签的索引 = 图片列表的长度-文件夹的数量+当前生成的第几个文件夹
          const currentIndex = collectTagList.length - paibanData.length + j
          it = collectTagList[currentIndex].url.split(',')[1] // 获取到是对应的余料标签
          filename = collectTagList[currentIndex].fileName
          idx--
        }
        const time = Date.now() + 8 * 3600 * 1000
        currentZip.file(
          `${filename}.${ncSetting.labelImageFormat || 'jpg'}`,
          it,
          { base64: true, date: new Date(time) }
        )
        const labelName =
          // '标签图/' +
          imgFileName +
          '/' +
          firstLevelFileName +
          `/${dirname}/` +
          `${filename}.${ncSetting.labelImageFormat || 'jpg'}`
        labelImgList[j].push({
          name: labelName,
          url: it,
          stock_key: collectTagList[idx].stock_key,
          size: collectTagList[idx].size,
          surplusInfo: collectTagList[idx]?.surplusInfo,
        })
        idx++
      })
    }
  } else {
    if (firstLevelFileName) {
      const folders = zip.folder(firstLevelFileName)
      const folder = folders?.folder(`${imgFileName}`)
      if (folder) currentZip = folder
    }
    collectTagList.forEach((item: any, index: number) => {
      const url = item.url.split(',')[1]

      currentZip.file(
        `${item.fileName}.${ncSetting.labelImageFormat || 'jpg'}`,
        url,
        { base64: true }
      )
      const surplusFolder: string = _translateFileNameFn(
        '余料大板文件',
        ncSetting.customizeFolder,
        'surplus_folder',
        item
      )

      let labelName: string = _translateFileNameFn(
        '标签图',
        ncSetting.customizeFolder,
        'label_image_folder',
        item
      )
      if (hasLabelImageInNcFolderPermission && store.state.isFollowExportTag) {
        labelName = _translateFileNameFn(
          '下料文件',
          ncSetting.customizeFolder,
          'engraving_folder',
          item
        )
        labelName = labelName ? labelName + '/label/image/' : '' // 定制需求 label_image_in_nc_folder一般为false
      } else {
        const { surplusInfo } = item
        labelName =
          surplusInfo && !surplusInfo?.other_plate && is_gen_surplus_folder
            ? surplusFolder
              ? `${surplusFolder}/${labelName}` + '/'
              : ''
            : labelName
            ? labelName + '/'
            : ''
      }
      const flagFolderName: string = !flag
        ? firstLevelFileName + `/${imgFileName}(${templateName})/`
        : ''
      const finalFilePath =
        labelName +
        flagFolderName +
        `${item.fileName}.${ncSetting.labelImageFormat || 'jpg'}`
      let newFileName = dealJinxiPaibanFolder(finalFilePath, surplusFolder)
      if (
        merge_folder_list.length > 1 &&
        merge_folder_list.includes('贴标图片文件') &&
        platePropertyMergeFile
      ) {
        const path = dealTransFileName(item, false)
        newFileName = `${merge_folder_display_name}/${path}${item.fileName}.${
          ncSetting.labelImageFormat || 'jpg'
        }`
      }
      // 贴标图片(非pdf)插入到下料文件F里面
      /**
       * 1、开启 将雕刻机正/反面文件用不同文件夹放置 功能
       * 2、区分材质
       */
      const folderSetting =
        store.state.mergeFolderSetting ?? ncSetting.customizeFolder
      if (folderSetting.engraving_front_back_folder) {
        // 获取下料文件名
        const engravingTranslateFileName = genEngravingFileName(
          item,
          folderSetting
        )
        let nextFileName = ''
        if (
          ncSetting.folderCategory &&
          ncSetting.folderCategory.useCategoryFolder
        ) {
          // 获取颜色、材质、厚度相同的文件放入相同文件夹
          nextFileName = item.stock_key.replace(/:/g, '_') + '/'
        }
        // 按照材质颜色厚度尺寸得到其文件夹名称，优先级比颜色材质厚度高
        if (ncSetting.folderCategory?.use_category_size_folder) {
          nextFileName =
            (getFolderClassifyNameByMatCodeTextureThickSize(item.o_stock_key) ??
              nextFileName) + '/'
        }
        nextFileName = removeHeadAndTail(nextFileName)
        newFileName =
          engravingTranslateFileName +
          'F/' +
          nextFileName +
          `${item.fileName}.${ncSetting.labelImageFormat || 'jpg'}`
      }
      labelImgList[0].push({
        name: newFileName,
        url: url,
        stock_key: item.stock_key,
        size: item.size,
        surplusInfo: item?.surplusInfo,
      })
    })
  }
  const data = await zip.generateAsync({ type: 'blob' })
  return {
    data,
    zip,
    labelImgList,
  }
}
// 处理补偿位数
export function prefixInteger(num: number, n: number) {
  return (Array(n).join('0') + num).slice(-n)
}
export function plankOrderCompensationDigits(num: number, n: number) {
  return num.toString().padStart(n, '0')
}
// 处理导出板件文件的名称
async function dealExportTagFileName(
  drawData: any,
  store: StoreType,
  ncFileList: any[],
  plantData: any[]
) {
  let ncFileArr = ncFileList
  const { ncSetting } = store.state
  const { type, plank_index, part } = drawData
  const separator = ncSetting.label_image_name_separator
  const ncCustomLabel = ncSetting.label_image_name_type ?? []
  let ncFileName = ''
  let labelFileName = ''
  let ncAutoIndex = ''
  if (
    (ncCustomLabel.some((type: any) =>
      ['labeling_filename', 'nc_filename', 'auto_index'].includes(type)
    ) ||
      ncSetting.label_img_big_plank_folder) &&
    !ncFileList.length
  ) {
    let paibanData = JSON.parse(JSON.stringify(plantData))
    paibanData.forEach((item: any) => {
      if (item.parts.some((part: PartType) => part.isWeldingPlank)) {
        item.isWeldingPlank = true
      }

      // 用于混排字段处理， 后端要求texture和oriTexture一致都表示原始值，newTexture表示新的值
      item.parts.forEach((part: any) => {
        part.texture = part._oriTexture || part.oriTexture
        part.newTexture = part.texture
      })
      item.parts.sort((a: any, b: any) => a.priority - b.priority)
    })
    // xy互换大板的四边修边已经转了，传给nc要转回去
    paibanData = paibanData.map((plank: any) => ({
      ...plank,
      margin: fourTrimEdge(
        String(
          plank.surplusInfo && plank.surplusInfo.is_plus
            ? plank.isUseSaw
              ? plank.margin
              : store.state.selectStandardPlank.plankEdgeOff
            : plank.margin
        ),
        ncSetting
      ),
    }))

    const newData = changeDataStartPoint(paibanData)
    newData.forEach((item: any) => {
      const surplusInfo = item.surplusInfo
      if (
        surplusInfo &&
        surplusInfo.is_plus &&
        surplusInfo.shape == 'lshape' &&
        surplusInfo.path &&
        surplusInfo.path.length
      ) {
        Object.assign(surplusInfo, dealLshapeTurnPoints(surplusInfo.path))
      }
      item.parts = item.parts.filter((it: any) => !it.blueAreaSurplus)
      item.parts.forEach((part: any) => {
        part.edgeInfo_desc_LW = getEdgeTypeWithRect(part.edgeInfo, part.rect)
      })
    })
    // TODO wc newNC调用两次的优化
    // store.state.newNCRes ??
    newData.forEach((item: any) => {
      item.parts.forEach((part: any) => {
        if (judgeIsMergeFrameDoor(part)) {
          // 清掉合并骨骼门 为绘制所构造的线槽数据（如果不删除 后端会去加工）
          part.lineSlots = []
        }
      })
    })
    // 去掉newNC传给后端的小板无用字段
    newData.forEach((item: any) => {
      item.parts = item.parts.map((part: any) => pickNcPartFields(part))
    })
    const nc = await httpRequest.post('new_nc', {
      uid: store.state.userInfo.id,
      data: JSON.stringify(newData),
      id:
        ncSetting.process_setting_name == '默认生产线'
          ? -1
          : ncSetting.process_setting_id,
      keepKnifeOrigin: true,
      from: 'web',
      embedded: sessionStorage.getItem('embedded') ? 1 : 0,
      guigui_version: sessionStorage.getItem('guigui_version'),
      version: 'v1',
      longPlankCuttingSetting: ncSetting.longPlankCuttingSetting,
      from_label: true,
    })
    ncFileArr = nc.data
    if (nc.data?.knife_error) {
      // 用于临时处理找不到刀错误
      EventBus.$emit(EventBusKey.KNIVES_ERR, nc.data.data, true)
      throw '找不到刀报错'
    }
    // 另外的刀相关的错误信息抛出在外面进行处理
    if (nc.status === 0) {
      EventBus.$emit(EventBusKey.OTHER_KNIVES_ERR, nc.msg)
      throw '刀错误信息'
    }
  }
  ncFileName = dealFileArrfunc(part, ncFileArr, 'nc')
  labelFileName = dealFileArrfunc(part, ncFileArr, 'label')
  ncAutoIndex = dealFileArrLabel(part, ncFileArr)
  const fileNameMap = new Map([
    ['address', part['address']],
    ['orderNo', part['orderNo']],
    ['nc_filename', ncFileName],
    ['labeling_filename', labelFileName],
    [
      'plankNum',
      ncSetting.genSimpleLabelBarcode ? part.simplePlankNum : part['plankNum'],
    ],
    ['auto_index', ncAutoIndex],
    ['stockNum', plank_index],
    ['priority', part['priority']],
    ['labelId', part['labelId']],
  ])
  const { front_file_identifier } = ncSetting
  let plankNum = ncSetting.genSimpleLabelBarcode
    ? part.simplePlankNum
    : String(part['plankNum'])
  if (
    part.specialType == 'supplus' ||
    (part.surplusPath && part.surplusPath.length > 0)
  ) {
    plankNum += front_file_identifier
  }
  fileNameMap.set('plankNum', plankNum)
  let fileName = ''
  if (type === 'plank') {
    fileName = `${plank_index}`
  } else {
    fileName = ncCustomLabel.length
      ? ncCustomLabel.map((type: any) => fileNameMap.get(type)).join(separator)
      : `${part.lableImgName}${separator}${plank_index}${separator}${part['priority']}`
  }
  fileName = appendSubTagFileNameSuffix(fileName, drawData)
  return { fileName, ncFileList: ncFileArr }
}
// 文件数组的处理
export function dealFileArrfunc(plank: any, fileList: any[], fileType: any) {
  const labelFiles = fileList
    .filter(
      (file) => file.filetype == fileType && file.stock_key == plank['stockKey']
    )
    .map((f) => {
      const nameArr = f.file_display_name.split('.')
      return nameArr.slice(0, nameArr.length - 1).join('.')
    })
  const ncFileName =
    labelFiles.length > 1
      ? labelFiles[0].endsWith('Z')
        ? labelFiles[1]
        : labelFiles[0]
      : labelFiles[0]
  return ncFileName
}
export function dealFileArrLabel(plank: any, fileList: any[]) {
  const ncAutoIndexList = Array.from(
    new Set(
      fileList
        .filter((file) => file.labeling_auto_index)
        .map((item) => {
          return {
            [item.stock_key]: item.labeling_auto_index,
          }
        })
    )
  )
  for (const item of ncAutoIndexList) {
    if (item[plank.stockKey]) {
      // 拿到的是数组
      return item[plank.stockKey][plank.stockKey][plank.priority - 1]
    }
  }
  return ''
}
// 处理导出余料板件文件的名称
function dealExportLaveTagFileName(drawData: any, store: StoreType) {
  const { plank, plank_index } = drawData
  const { ncSetting } = store.state
  const separator =
    ncSetting.label_picture_delimiter == 'underline'
      ? ncSetting.label_image_name_separator
      : ''
  const fileName = `${plank.lableImgName}${separator}${plank_index}`
  return fileName
}
function timer(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
// 将文件名称和文件url重新组合并收集
async function dealMergeFileNameOrUrl(
  fileName: string,
  collect: any[],
  ncSetting: any,
  stock_key?: string,
  size?: string,
  surplusInfo?: boolean,
  options?: {
    // 麻了。我也不知道里面有什么数据
    current: any
  }
) {
  const { current } = options ?? {}
  const idx = collect.length ? collect.length - 1 : 0
  let url = collect[idx]
  // 导出图片后缀和编码格式均为bmp时，支持位深1导出
  if (
    ncSetting.bmp_color_style &&
    ncSetting.labelImageFormat == 'bmp' &&
    ncSetting.labelImageFormatNew == 'bmp'
  ) {
    const newBase64 = await exportBmp1Bit(url)
    url = newBase64
  } else {
    if (ncSetting.labelImageFormatNew == 'bmp') {
      url = await convertJpegToBmp.convertJpegToBmp(url)
    } else {
      const oCanvas = cvs2image(url)
      await timer(20)
      const { width, height } = oCanvas
      const imgDom: any = canvas2Image.convertToImage(
        oCanvas,
        width,
        height,
        ncSetting.labelImageFormatNew
      )
      url = imgDom.src
    }
  }
  // id 用于记录其对应的大板或者小板，找寻源时有用
  const plankId = isPartTagType(current.type)
    ? current.part.partUniqueId
    : current.plank.bigPlankUniqueId
  collect[idx] = {
    plankId,
    fileName,
    url,
    stock_key,
    size,
    surplusInfo,
    o_stock_key: current?.plank?.stockKey,
  }
}
// 生成文件 10
export async function generateTagFile(
  data: any[],
  template: any,
  store: StoreType,
  load: { isTag: boolean; isPdf: boolean } = { isTag: true, isPdf: false },
  lifeFunc: LifeFuncType = {},
  ncLifeFuncObj: any,
  config?: {
    isNewGen?: boolean
    tagSetting?: TagSettingType
    isFollowExportTag?: boolean
    fileName?: string
    fileNameList?: any[]
    isSendToFactory?: boolean
    /** 自动贴标确认继续后跳过副标签生成 */
    skipSubTag?: boolean
    callBackFunc?: (
      taglist: { isFinished: boolean; data: TagType[]; index: number } | string
    ) => void
  }
) {
  try {
    transformToEzSort.clear()
    // 周期函数
    const {
      loadSetting,
      loadPreferences,
      dealTemp,
      initialData,
      dealDrawData,
      genTagImg,
      genTagPdf,
      done,
    } = lifeFunc
    let ncloadPreferences, ncdealTemp
    if (ncLifeFuncObj) {
      const { ncloadPreferences: ncL, ncdealTemp: ncT } = ncLifeFuncObj
      ncloadPreferences = ncL
      ncdealTemp = ncT
    }
    // eslint-disable-next-line prefer-const
    let { data: currentTemplate, name: templateName, render_url, id } = template
    if (!currentTemplate && !render_url && id) {
      done && done('end')
      return
    }
    currentTemplate && (currentTemplate = JSON.parse(currentTemplate))
    // 获取设置
    loadSetting && loadSetting('start')
    ncloadPreferences && ncloadPreferences('start')
    if (render_url) {
      render_url = render_url.replace(/http:/g, 'https:')
      currentTemplate = await axios
        .get(render_url)
        .then((result) => result.data)
        .catch(() => {
          done && done('end')
        })
    }
    currentTemplate = ensureTagDataDefaults(currentTemplate)
    // 自动贴标生产线确认继续后不生成副标签
    if (config?.skipSubTag) {
      currentTemplate = {
        ...currentTemplate,
        enable_sub: false,
      }
    }
    const setting = await getFileSetting(store)
    loadSetting && loadSetting('end')
    ncloadPreferences && ncloadPreferences('end')
    // 获取偏好设置
    loadPreferences && loadPreferences('start')
    const preferencesSetting = await getPreferencesSetting()
    loadPreferences && loadPreferences('end')
    // 处理模板,获取文件后缀
    let ncNameSuffix = ''
    let ncOutputSetting = {}
    if (store.state.ncSetting && store.state.ncSetting.process_setting_id) {
      dealTemp && dealTemp('start')
      ncdealTemp && ncdealTemp('start')
      const res = await getEngravingSetting(store, currentTemplate)
      ncNameSuffix = res.ncNameSuffix
      ncOutputSetting = res.ncOutputSetting
      dealTemp && dealTemp('end')
      ncdealTemp && ncdealTemp('end')
    }

    // 初始化数据
    initialData && initialData('start')
    let { data: sourceData } = initTagData(
      data,
      store,
      setting,
      config?.isNewGen
    )
    // 初始化余料数据
    const laveData = initLaveData(sourceData, store)
    // 镜像处理 wc 新标签不需要做特殊镜像处理
    // if (preferencesSetting.jx_checked) {
    //   laveData = JxTagData(laveData)
    //   sourceData = JxTagData(sourceData)
    // }
    // 默认数据
    const default_sort_source_data = sourceData
    // 自动上下料
    if (preferencesSetting.sort_value) {
      if (preferencesSetting.sort_value === 'default') {
        preferencesSetting.sort_value = 1
      }
      sourceData =
        preferencesSetting.sort_value === 1
          ? default_sort_source_data
          : (countTagDataByDir(
              preferencesSetting.sort_value,
              sourceData,
              store.state.ncSetting.xyReverse
            ).tagItemArr as any)
    }
    initialData && initialData('end')
    // 处理绘制数据
    dealDrawData && dealDrawData('start')
    const isGenFiveSixDir = preferencesSetting.five_six_dir

    if (store.state.ncSetting.process_setting_id) {
      const res = await fetchPlankReference({
        process_setting_id: store.state.ncSetting.process_setting_id,
        bigPlanks: dealDrawDataForTag(sourceData),
      })

      if (res.status) {
        const planks = dealDrawDataForTag(JSON.parse(res.data.bigPlanks))
        sourceData = planks
      } else {
        if (res.status === 0 && res?.msg) {
          throw new Error(`获取放板基准数据错误，请稍后再试！${res.msg}`)
        } else {
          throw new Error(translateLang('获取放板基准数据错误，请稍后再试！'))
        }
      }
    }

    const { tagListSourceData, bigTagList, all_page } = tagDrawPreDeal(
      sourceData,
      ncNameSuffix,
      setting,
      preferencesSetting,
      store.state.ncSetting,
      ncOutputSetting,
      preferencesSetting, // 这什么意思，传了两个偏好设置
      currentTemplate
    )
    const laveTagListSourceData = laveTagDrawPreDeal(
      laveData,
      preferencesSetting
    )
    dealDrawData && dealDrawData('end')
    let tagData = null
    let pdfData = null

    if (config && config.isNewGen) {
      const dataArr = sourceData
      const finalDataArr = dataArr.map((data) => {
        const plank = data
        const { size } = getGraghEdge(plank)
        plank.plankSize = size
        // plank.parts = sourceData.filter(
        //   (i) => i.plank_index == data.plank_index && i.type !== 'plank'
        // )[0].parts
        // .map((i) => ({ ...i.currentPlank, plankIndex: data.plank_index }))
        plank.plankIndex = data.plank_index

        return plank
      })
      finalDataArr.forEach((plank) => {
        const plank_index = plank.canvasIndex
        plank.parts.forEach((part: any) => {
          if (part['specialType'] == 'supplus') {
            // 获取余料边长信息
            part.plankSize = getSurplusSize(part, store.state.ncSetting).str
            if (sessionStorage.getItem('thinkerx_material')) {
              part.plankSize += `*1`
            } else {
              part.plankSize += `*${plank.thick}`
            }
            const textArr = plank.plankSize.split('*')
            if (plank.surplusInfo?.isNotSurplus || !plank.surplusInfo) {
              textArr[0] = plank.plankHeight
              textArr[1] = plank.plankWidth
            }
            const infoObj = {
              oSize: part.plankSize,
              oSize_L: part.plankSize
                .split('*')
                .splice(0, part.plankSize.split('*').length - 1)
                .join('*'),
              matCode: part.matCode,
              bigPlankID: plank_index + '',
              plank_index: `第${plank_index}张大板`,
              // lable_index: `第${label_num + 1}/${all_page}页`,
              paibanTime: getPaibanTime(),
              oriPlankNum: part.oriPlankNum,
              plankSize: `${textArr[1]}*${textArr[0]}*${textArr[2]}`,
              texture: part.texture,
              // 所在余料库
              branch_no: part.branch_name || '-',
            }
            part['surplusDrawObj'] = infoObj
          }
        })
      })

      const bigTemplate = {
        ...bigPlankTemp,
        tag_width: currentTemplate.tag_width,
        tag_height: currentTemplate.tag_height,
      }
      await escapeTemplate(currentTemplate)
      await escapeTemplate(bigTemplate)
      transformToEzSort.setPattern(load.isPdf ? 'pdf' : 'img')

      const exportTagPromise = (
        configData: any
      ): Promise<
        { isFinished: boolean; data: TagType[]; index: number } | string
      > => {
        return new Promise((resolve) => {
          tagDraw.exportTag(
            {
              paibanData: finalDataArr,
              templateData: currentTemplate,
              configData,
            },
            (cbData: any) => {
              config.callBackFunc && config.callBackFunc(cbData)
              if (
                typeof cbData?.src === 'string' ||
                (typeof cbData === 'object' && cbData.isFinished)
              ) {
                resolve(cbData)
              }
            }
          )
        })
      }

      // 1. 先导出图片标签
      if (load.isTag) {
        genTagImg && genTagImg('start')
        const imgResult = await exportTagPromise({
          format: store.state.ncSetting.labelImageFormatNew || 'png',
          type: 'img',
          ncSetting: store.state.ncSetting ?? {},
          bigPlankTemp: bigTemplate,
          tagSetting: config.tagSetting,
          fileSetting: setting,
          ncOutputSetting,
          ncNameSuffix,
          paibanTime: getPaibanTime(),
          isFollowExportTag: config.isFollowExportTag,
          typesettingBatch: store.state.typesettingBatch ?? '',
          fileNameList: config?.fileNameList ?? [],
        })
        genTagImg && genTagImg('end')

        if (
          !config.callBackFunc &&
          typeof imgResult !== 'string' &&
          imgResult.isFinished
        ) {
          const tagList =
            (await dealTagFileName(imgResult.data, data)) ?? imgResult.data
          const processedTagData = {
            collect: [] as any[],
            LaveTagBase64List: [] as string[],
            bigplantLableList: [] as string[],
          }
          dealTagFileObj(tagList, data, {
            laveTagListSourceData: [],
            tagListSourceData: [],
            tagData: processedTagData,
          })
          processedTagData.collect.forEach((tag, tagIndex) => {
            if (['part', 'surplus'].includes(tag.type)) {
              transformToEzSort.changeImageFileName(
                tag.part,
                tag.fileName,
                store.state.ncSetting.labelImageFormat,
                tag.label_num ?? tagIndex
              )
            }
          })
          tagData = processedTagData
        }
      }
      // 2. 图片标签完成后再导出 PDF（顺序执行，避免并发问题）
      if (load.isPdf) {
        genTagPdf && genTagPdf('start')

        const pdfResult = await exportTagPromise({
          format: store.state.ncSetting.labelImageFormatNew || 'png',
          type: 'pdf',
          ncSetting: store.state.ncSetting,
          bigPlankTemp: bigTemplate,
          tagSetting: config.tagSetting,
          fileSetting: setting,
          ncOutputSetting,
          ncNameSuffix,
          paibanTime: getPaibanTime(),
          typesettingBatch: store.state.typesettingBatch ?? '',
          fileName: config?.fileName ?? 'test',
          isSendToFactory: config.isSendToFactory,
        })
        genTagPdf && genTagPdf('end')
        if (!config.callBackFunc) {
          const pdfSrc =
            typeof pdfResult === 'string' ? pdfResult : (pdfResult as any).src
          pdfData = dealPDFFileObj(pdfSrc, templateName)
        }
      }
    } else {
      // 是否需要生成标签或 PDF
      const needTag = load.isTag || load.isPdf
      // 设置标签类型
      transformToEzSort.setPattern(load.isTag ? 'img' : 'pdf')
      if (needTag) {
        if (load.isTag) genTagImg?.('start')
        if (load.isPdf) genTagPdf?.('start')
        tagData = await generateImageTag(
          tagListSourceData,
          laveTagListSourceData,
          currentTemplate,
          store,
          {
            ...preferencesSetting,
            scale: 2,
            all_page,
          },
          data
        )
        if (load.isTag) genTagImg?.('end')
        if (load.isPdf) {
          const svgList = tagData.collectSvg.map((item: any) => item.url)
          // 加载字体
          await jsPdfTool.loadFontByTagTemp([
            ...(currentTemplate.tem_data ?? []),
            ...(currentTemplate.surplus_data ?? []),
            ...(currentTemplate.surplus_waste_data ?? []),
            ...(currentTemplate.sub_tem_data ?? []),
          ])
          const binary = await getSvgListToPdfJSBinary(svgList, {
            unit: 'mm',
            format: [currentTemplate.tag_width, currentTemplate.tag_height],
          })
          pdfData = {
            data: binary,
            name: templateName,
          }
          genTagPdf?.('end')
        }
      }
    }
    done && done('end')
    return {
      tagData,
      pdfData,
      tagListSourceData,
      laveTagListSourceData,
    }
  } catch (error) {
    console.error(error)
    return false
  }
}
function svgToBase64(svgString: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURI(svgString)}`
}

export function dealDrawDataForTag(sourceData: PlankType[]) {
  const newData = window.$copy(sourceData) as PlankType[]
  const { ncSetting } = store.state
  const {
    auto_adaptation_xy_reverse: isXyReverseAuto,
    xyReverse,
    startPosition,
  } = ncSetting
  if (isXyReverseAuto && xyReverse) {
    newData.forEach((plank) => {
      plank.parts = plank.parts.map((part) => {
        return getPartXyReverse(part, startPosition)
      })
    })
  }

  return newData
}
/**
 *
 * @param collect 所有的标签数据列表
 * @param paibanData 排版数据
 * @returns 处理后的标签数据列表(带标签文件名)
 */
export async function dealTagFileName(collect: TagType[], paibanData: any[]) {
  const ncSetting = store.state.ncSetting
  /** 自定义标签图片文件名 */
  const labelImageNameArr: string[] = ncSetting.label_image_name_type
  if (labelImageNameArr.length) {
    /** NC 文件列表 */
    const ncFileList: any[] = []
    // 如果标签文件名包含下料文件名，则获取下料文件名
    if (
      labelImageNameArr.includes('nc_filename') ||
      labelImageNameArr.includes('auto_index') ||
      labelImageNameArr.includes('labeling_filename')
    ) {
      const newData = changeDataStartPoint(paibanData)
      newData.forEach((item: any) => {
        item.parts = item.parts.map((part: any) => pickNcPartFields(part))
      })
      const nc = await httpRequest.post('new_nc', {
        uid: store.state.userInfo.id,
        data: JSON.stringify(newData),
        id:
          store.state.ncSetting.process_setting_name == '默认生产线'
            ? -1
            : store.state.ncSetting.process_setting_id,
        keepKnifeOrigin: true,
        from: 'web',
        embedded: sessionStorage.getItem('embedded') ? 1 : 0,
        guigui_version: sessionStorage.getItem('guigui_version'),
        version: 'v1',
        longPlankCuttingSetting: store.state.ncSetting.longPlankCuttingSetting,
        from_label: true,
      })
      ncFileList.push(...nc.data)
    }

    const tagList = collect.map((tag) => {
      let tagFileName = ''
      // 如果是大板标签,直接以大板序号命名
      if (tag.type == 'plank') {
        tagFileName = String(tag.plank_index)
      } else if (tag.type == 'lave') {
        // 如果是余料(废料)标签,直接以余料序号命名
        tagFileName = [new Date().getTime(), String(tag.plank_index)].join(
          ncSetting.label_image_name_separator
        )
      } else {
        const part = tag.part
        // 处理下料文件名
        const ncFileName = labelImageNameArr.includes('nc_filename')
          ? dealFileArrfunc(part, ncFileList, 'nc')
          : ''
        // 处理贴标文件名
        const labelFileName = labelImageNameArr.includes('labeling_filename')
          ? dealFileArrfunc(part, ncFileList, 'label')
          : ''
        // 处理自动贴标序号
        const ncAutoIndex = labelImageNameArr.includes('auto_index')
          ? dealFileArrLabel(part, ncFileList)
          : ''
        const fileNameMap = new Map([
          ['address', part['address']],
          ['orderNo', part['orderNo']],
          ['nc_filename', ncFileName],
          ['labeling_filename', labelFileName],
          [
            'plankNum',
            ncSetting.genSimpleLabelBarcode
              ? part.simplePlankNum
              : part['plankNum'],
          ],
          ['auto_index', ncAutoIndex],
          ['stockNum', tag.plank_index],
          ['priority', part['priority']],
          ['labelId', part['labelId']],
        ])
        // 如果是零件标签,根据自定义标签文件名生成
        const tagFileNameArr = labelImageNameArr.map((labelImageName) => {
          return fileNameMap.get(labelImageName)
        })
        tagFileName = tagFileNameArr.join(ncSetting.label_image_name_separator)
      }

      return {
        ...tag,
        tagFileName: appendSubTagFileNameSuffix(tagFileName, tag),
      }
    })
    return tagList
  }
}

/**
 * 处理标签文件夹  TODO wc
 * @param tagList 标签数据列表
 * @returns 处理后的标签文件夹
 */
export async function dealTagFileFolder(tagList: TagType[]) {
  const ncSetting = store.state.ncSetting
  const labelImageNameArr: string[] = ncSetting.label_image_name_type
  const rootFolder = ncSetting.customizeFolder.label_image_folder
  const tagFileFolderList: string[] = []
}

export function dealTagFileObj(
  tagList: TagType[],
  data: any[],
  obj: {
    laveTagListSourceData: any[]
    tagListSourceData: any[]
    tagData: {
      collect: any[]
      LaveTagBase64List: string[]
      bigplantLableList: string[]
    }
  }
) {
  for (let idx = 0; idx < data.length; idx++) {
    const stockData = data[idx]
    obj.laveTagListSourceData.push({
      plank: stockData,
      plank_index: stockData.plank_index,
      type: 'laveTag',
    })
  }

  for (let idx = 0; idx < tagList.length; idx++) {
    const tag = tagList[idx]

    if (tag.type != 'lave' && !tag.isRestTag) {
      if (tag.type == 'plank') {
        obj.tagListSourceData.push({
          plank: tag,
          plank_index: tag.plank_index,
          part: tag.plank.parts[0],
          type: 'plank',
        })
      } else {
        obj.tagListSourceData.push({
          plank: tag.plank,
          part: tag.part,
          part_index: tag.part.priority - 1,
          currentPlank: tag.plank,
          type: tag.type === SUB_TAG_TYPE ? SUB_TAG_TYPE : 'tag',
        })
      }
    }

    const plank = tag.plank as any

    obj.tagData.collect.push({
      ...tag,
      url: tag.src,
      fileName: tag.tagFileName,
      size: plank.plankHeight * plank.plankWidth,
    })
    if (tag.type == 'lave' || tag.isRestTag) {
      obj.tagData.LaveTagBase64List.push(tag.src)
    }

    if (tag.type == 'plank') {
      obj.tagData.bigplantLableList.push(tag.src)
    }
  }
}

export function dealPDFFileObj(pdfSrc: string, templateName: string) {
  // 去掉前缀（如果有，例如 "data:image/png;base64,"）
  const cleanedBase64 = pdfSrc.replace(/^data:.*?base64,/, '')

  const binaryString = atob(cleanedBase64) // base64 解码为二进制字符串
  const len = binaryString.length
  const bytes = new Uint8Array(len)

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  return {
    data: bytes.buffer, // 返回 ArrayBuffer 对象,
    name: templateName,
  }
}

/**
 * 将结构中出现的 `Map` 递归转为普通对象（键为 Map 的 key，值为递归处理后的值）。
 * 用于控制台/序列化场景下把 `Map` 转成可 JSON 或易读的结构。
 */
export function deepMapsToPlain<T>(data: T): T {
  if (data instanceof Map) {
    const plain: Record<string, unknown> = {}
    for (const [key, val] of data.entries()) {
      const k = String(key)
      plain[k] = deepMapsToPlain(val)
    }
    return plain as T
  }

  if (Array.isArray(data)) {
    return data.map((item) => deepMapsToPlain(item)) as unknown as T
  }

  if (data !== null && typeof data === 'object') {
    if (data instanceof Date || data instanceof RegExp) {
      return data
    }
    const obj = data as Record<string, unknown>
    const out: Record<string, unknown> = {}
    for (const key of Object.keys(obj)) {
      out[key] = deepMapsToPlain(obj[key])
    }
    return out as T
  }

  return data
}
